import { useSize } from 'ahooks'
import { FloatButton } from 'antd'
import { createStyles } from 'antd-style'

import { RouterOutlet } from '@eastcoal/router/components/Outlet'

import { LayoutFooter } from '../components/Footer'
import { LayoutHeader } from '../components/Header'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    minWidth: token.layoutContentWidth,
    backgroundColor: token.colorBgLayout
  }
}))

export const BaseLayout = () => {
  const bodySize = useSize(document.body)
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <LayoutHeader />
      <RouterOutlet />
      <LayoutFooter />
      <FloatButton.BackTop
        tooltip='返回顶部'
        visibilityHeight={bodySize?.height}
      />
    </div>
  )
}
